import script from "./WorkbenchCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkbenchCenter.vue?vue&type=script&setup=true&lang=js"

import "./WorkbenchCenter.vue?vue&type=style&index=0&id=21f57a2d&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21f57a2d"]])

export default __exports__